import { List, Skeleton, Modal, Button, Typography } from 'antd'
import InfiniteScroll from 'react-infinite-scroll-component';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useGetAllCommentMails } from '../utils/queryUtils';
import { useState } from 'react';

export default function Mail({ canNavigate, openSendMailModal, height, width, setShowInboxPopover }) {
  const navigate = useNavigate();
  const { company: selectedCompany } = useSelector(st => st.selected);

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isLoading
  } = useGetAllCommentMails(selectedCompany?._id);

  const mails = data?.pages.flatMap(page => page.data) || [];

  const [openMailItem, setOpenMailItem] = useState(null);

  if (isLoading) {
    return <Skeleton active />;
  }

  return (
    <div className="position-relative">
      <div
        className="d-flex justify-content-between"
        style={{ width: `${width}px` }}
      >
        <h2>Inbox</h2>
      </div>
      <div
        style={{
          overflow: "auto",
          height: `${height - 50}px`,
          width: `${width}px`,
        }}
        id="scrollableDiv"
      >
        <InfiniteScroll
          dataLength={mails.length}
          next={fetchNextPage}
          hasMore={!!hasNextPage}
          loader={<Skeleton.Input active size="small" block />}
          scrollableTarget="scrollableDiv"
        >
          <List
            dataSource={mails}
            renderItem={(item, i) => (
              <List.Item
                key={i}
                onClick={() => {
                  // Open modal to show mail preview and sender info instead of navigating immediately
                  setOpenMailItem(item);
                }}
                className={canNavigate && "pointer"}
              >
                <div
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {item?.text}
                </div>
              </List.Item>
            )}
          />
        </InfiniteScroll>
      </div>
      {/* Mail preview modal */}
      <Modal
        title={openMailItem ? `${openMailItem.created_by?.first_name ?? ''} ${openMailItem.created_by?.last_name ?? ''}` : 'Mail'}
        open={!!openMailItem}
        onCancel={() => setOpenMailItem(null)}
        footer={(
          openMailItem && openMailItem.fy && openMailItem.fy._id && openMailItem.fy.client && openMailItem.fy.client._id
        ) ? [
          <Button key="close" onClick={() => setOpenMailItem(null)}>Close</Button>,
          <Button key="open" type="primary" onClick={() => {
            // navigate to queries with context
            setShowInboxPopover(false);
            navigate(`/queries?fy=${openMailItem.fy._id}&entity=${openMailItem.fy.client._id}&company=${openMailItem.fy.company}&showEmail=true`);
            setOpenMailItem(null);
          }}>Open Query</Button>
        ] : [<Button key="close" onClick={() => setOpenMailItem(null)}>Close</Button>]}
      >
        <div style={{ minHeight: 100, maxHeight: 400, overflow: 'auto' }}>
          <Typography.Paragraph>
            {openMailItem?.text}
          </Typography.Paragraph>
          {openMailItem?.created_by && (
            <Typography.Text type="secondary">From: {openMailItem.created_by.first_name} {openMailItem.created_by.last_name} &lt;{openMailItem.created_by.email}&gt;</Typography.Text>
          )}
        </div>
      </Modal>
    </div>
  );
}